import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class AccountValueError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AccountValueError', ...args);
    }
}
export default AccountValueError;
